import React, { PropsWithChildren } from 'react';
import SpinnerBase, { SpinnerBaseProps } from './spinnerBase';

import './scrim.scss';

export interface ScrimBaseProps extends SpinnerBaseProps {
  isActive?: boolean;
  hideSpinner?: boolean;
  fullHeight?: boolean;
}
type OwnProps = ScrimBaseProps & {
  label?: string;
};
type Props = PropsWithChildren<OwnProps>;
const ScrimBase: React.FC<Props> = (props) => {
  const { isActive, iconSize, label, mode, children } = props;
  const minHeight = isActive ? Number(iconSize || 20) + 10 : 0;
  const condStyle = props.fullHeight ? { height: '100%' } : {};
  const style = { ...{ minHeight: `${minHeight}px` }, ...condStyle };

  return (
    <div className="scrim-box" style={style}>
      <div className={`scrim-panel${isActive ? ' panel-active' : ''}`}>
        {!props.hideSpinner && (
          <div className="panel-content">
            <SpinnerBase isReverse {...{ label, iconSize, mode }} />
          </div>
        )}
      </div>
      <div className="scrim-content">{children}</div>
    </div>
  );
};

export default ScrimBase;
